<div #chargeList class="chargeList" *ngIf=" firstPick">
    <!-- (pageLength>0) &&  -->
    <div class="records" [class.justify-content-flex-start]="!showPickup">
        <mat-form-field appearance="outline" fxFlex="17em">
            <input matInput (ngModelChange)="applyFilter($event)" placeholder="Search picked up containers" ngModel>
            <i class="flaticon-search" matSuffix></i>
        </mat-form-field>
        <div
                [matTooltip]="transactionType == 'supply' ? 'Marking pickup not available for Supply Requests, Mark pickup for Use requests and this page will be updated automatically.' : ''">
            <button mat-raised-button [class]="transactionType != 'supply' ? 'addBtn clickIt' : ''"
                    (click)="AddPickup()" *ngIf="showPickup && !isCustomer"
                    [disabled]="transactionType == 'supply' && requestType != 'buy_sell'">Add
                                                                                          Pick-up
            </button>
        </div>
    </div>
    <div class="title">
        <div class="t1 t1pl">
            <span class="desc"> Container Pick-up details: </span>
        </div>
        <logzy-chipper [label]="' Pending For Pick-up '"
                       [value]="releaseOrder?.pending_do_picked_up_quantity"></logzy-chipper>
    </div>
    <div class="teamTable setTable">
        <mat-table [dataSource]="pickupList" matSort (matSortChange)="announceSortChange($event)">
            <ng-container matColumnDef="container">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Container No.</mat-header-cell>
                <mat-cell *matCellDef="let element ;let i=index">
                    <div *ngIf="!element.isSwapMode" fxLayout="column" >
                    <span class="strikethrough-red" *ngIf="element.swapped_container != null && !element.isSwapMode">
                        {{element.swapped_container}}</span>
                        <span class="fw-medium">{{element.container.container_number}}</span>
                    </div>

                    <app-text-field [isEditable]="true" [(ngModel)]="element.container.container_number"
                                    *ngIf="element.isSwapMode" [name]="'description'"
                                    [errors]="errorObjs[i]?.container_number" fxLayout="column">
                    </app-text-field>

                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="container_size_type">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Size Type</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span>{{element.container?.container_size_type}}</span>
                </mat-cell>
            </ng-container>
            <!-- <ng-container matColumnDef="owner">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Owner</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span>{{element.dropoff_depot?.depot_owner_type?.value}}</span>
                </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="do_reference_no">
                <mat-header-cell *matHeaderCellDef mat-sort-header> DO No.</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13"> {{element.do_reference_no}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="pickup_depot">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Pick-up Depot</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-12">
                    {{element.pickup_depot?.name_display}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="ownership">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Ownership</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-12">
                    {{element.container?.ownership}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="pickup_date">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Pick-up Date</mat-header-cell>
                <mat-cell *matCellDef="let element" class="fs-13">
                    <!-- {{element.pickup_date | date}} -->
                    <app-date-field [isEditable]="false" [maxDate]="currentDate"
                                    [(ngModel)]="element.pickup_date"></app-date-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="user_remark">
                <mat-header-cell *matHeaderCellDef> Remarks</mat-header-cell>
                <mat-cell *matCellDef="let element ;let i=index" class="fs-13">
                    <!-- {{element.user_remark ?? '-'}} -->
                    <app-text-field [isMultiline]="true" [isEditable]="element.isEdit" [(ngModel)]="element.user_remark"
                                    [name]="'description'" [errors]="errorObjs[i]?.user_remark" class=""
                                    fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="swap_remark">
                <mat-header-cell *matHeaderCellDef> Swap Remarks</mat-header-cell>
                <mat-cell *matCellDef="let element ;let i=index" class="fs-13">
                    <app-text-field [isMultiline]="true" [isEditable]="element.isSwapMode"
                                    [(ngModel)]="element.swapping_remarks"
                                    [name]="'description'" [errors]="errorObjs[i]?.remarks" class="" fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                <mat-cell *matCellDef="let element; let i=index">
                    <!-- <div class="actions" (click)="deleteDOContainerPickup(element)">
                        <i class="flaticon-view"></i>
                    </div> -->
                    <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="transactionType == 'supply'">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="deleteDOContainerPickup(element)">
                            <span>Delete</span>
                        </button>
                        <button mat-menu-item [disabled]="element.isEdit || element.isSwapMode" (click)="edit(element)">
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item [disabled]="!element.isEdit && !element.isSwapMode"
                                (click)="saveChanges(element,i)">
                            <!-- Save -->
                            {{element.isSwapMode ? 'Swap Save' : 'Save'}}
                        </button>
                        <button mat-menu-item [disabled]="element.isEdit || element.isSwapMode"
                                (click)="edit(element,true)">Swap
                                                             Container
                        </button>
                        <button mat-menu-item (click)="cancel(element)">
                            <span>Cancel</span>
                        </button>
                    </mat-menu>
                    <!-- (click)="opendailog(element.container?.container_number)" -->
                </mat-cell>

            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" [class.blur]="loading"></mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!loading">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
        <ng-container *ngIf="billuLoader ">
            <logzy-billu [part1]="part1 " [part2]="part2 " [part3]="part3" font="14px"></logzy-billu>
        </ng-container>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of Charges"
                   [length]="pageLength" (page)="pageChanged($event)">
    </mat-paginator>
</div>


<div class="returnOrder" *ngIf="PickupContainer">
    <div class="title">
        <div class="t1">
            <!-- <span> Pick-up</span> -->
            <title-back [addTitle]="true" [Title]="'Pick-up'" (back)="backtoList()"></title-back>
            <span class="desc updatetitle">Select Release Order</span>
        </div>
        <div class="t2">
            <!-- <span *ngFor="let item of requestService.selectedRequest?.requirement">
                {{item?.quantity}}*{{item?.container_size_type?.display}} ({{item?.condition?.value}})
            </span> -->
            <mat-chip *ngFor="let item of requestService.selectedRequest?.requirement"
                      class="primary-chip sleek-chip container-chip">
                {{item?.quantity}}*{{item?.container_size_type?.display}} ({{item?.condition?.value}})
            </mat-chip>
            <!-- <mat-chip color="primary" selected> Pending For Pick-up: {{releaseOrder?.pending_do_picked_up_quantity
                }}</mat-chip> -->
            <logzy-chipper [label]="' Pending For Pick-up'"
                           [value]="releaseOrder?.pending_do_picked_up_quantity"></logzy-chipper>

        </div>
    </div>
</div>
<ng-container *ngIf="PickupContainer">
    <div class="inputs" style="    display: flex;
    flex-wrap: wrap;" *ngIf="cardLoader">
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
        <logzy-card-loader [type2]="true"></logzy-card-loader>
    </div>
    <mat-radio-group class="inputs" fxLayout="row wrap" id="pickUpContainer" *ngIf="!cardLoader">
        <ng-container *ngFor="let item of releaseOrder?.do_list;let index = index">
            <mat-radio-button value="{{item.do_reference_no}}" *ngIf="!(item.status=='Cancelled')"
                              [matTooltip]="'All containers are Picked up.'"
                              [matTooltipDisabled]="item.remaining_pickup_quantity !== null" matTooltipPosition="below"
                              (click)="select(item)" [disabled]="!item.remaining_pickup_quantity"
                              [class.radioDOQ0]="!item.remaining_pickup_quantity">
                <div class="pickupCard">
                    <!-- (click)="getContainerPickup(item)" -->
                    <div class="head">
                        <span class="releaseNo">{{item.do_reference_no}}</span>
                        <mat-chip class="headchip" color="primary" selected><span style="margin-right: 5px;">{{
                                item.requirement.container_size_type.display}} | </span> Pick-up pending:
                            {{item.remaining_pickup_quantity == null
                                ? "0" : item.remaining_pickup_quantity}}/{{item.quantity
                            == null ? "0" : item.quantity}}
                        </mat-chip>
                    </div>
                    <div fxLayout="column">
                        <div class="depotName">
                            <i class="flaticon-anchor"></i>
                            <span>{{item.depot?.display_name}}</span>
                        </div>
                        <div class="address">
                            <span>{{item.depot?.address}} </span>
                        </div>
                    </div>
                    <div class="foot">
                        <span class="validity">Valid till {{item.valid_till | date:"dd MMM, yyyy"}}</span>
                        <div fxLayout="row" class="gap-1">
                            <mat-chip class="footchip">{{item.do_owner?.value}}</mat-chip>
                            <mat-chip>{{item.is_open_do ? 'Open DO' : 'Closed DO'}}</mat-chip>
                        </div>
                    </div>
                </div>
            </mat-radio-button>
        </ng-container>
    </mat-radio-group>
    <div *ngIf="releaseOrder?.do_list.length < 1">
        <logzy-billu [button]="true" [part1]="'Create'" [part2]="'Release' " [part3]="'Order'" font="14px"
                     (action1)="navigatePickup()"></logzy-billu>
    </div>

    <ng-container *ngIf="pickupData">

        <!-- <div class="t1">
            <span class="desc">Here is the list of container already included for Pick-up </span>
        </div>

        <div fxFlex="100" fxLayout="column">
            <div class="HeaderSet">
                <span fxFlex="13.3" class="text-center ">Container No</span>
                <span fxFlex="13.3">DO No</span>
                <span fxFlex="17">Size-type</span>
                <span fxFlex="29.4">Current Depot Name</span>
                <span fxFlex="11">Pick-up Date</span>
                <span fxFlex="15.3">Pick-up Remarks</span>
                <span fxFlex="8">Actions</span>

            </div>
            <div class="rowSetBackground">
                <div class="rowSet rowSetShowcast" *ngFor="let item of containerPickupData">
                    <span fxFlex="13.3" class="imp text-center">{{item.container?.container_number}}</span>
                    <span fxFlex="13.3" class="imp">{{item.do_reference_no}}</span>
                    <span fxFlex="11">
                        {{item?.container?.container_size_type}}
                    </span>
                    <span fxFlex="29.4" class="imp">{{this.selectDO.depot?.display_name}}</span>
                    <span fxFlex="11" class="imp">{{item.pickup_date | date:"dd MMM, yyyy"}}</span>
                    <span fxFlex="15.3" class="imp">{{item.user_remark}}</span>
                    <button mat-button [matMenuTriggerFor]="menu" fxFlex="8" class="actions">
                        <mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="deleteDOContainerPickup(item)">Delete</button>
                    </mat-menu>
                </div>
            </div>
        </div> -->

        <div class="t1 m-t-15 t1p">
            <span class="desc">
                Simply copy paste the container numbers separated by space or comma and select Pick-up date
            </span>
        </div>
        <div class="inputs pl05em" fxLayout="row wrap" id="pickupForm">
            <div fxFlex="50%" fxLayout="column" *ngIf="selectDO.is_open_do==true">
                <span class="inputTitle">Container No*</span>
                <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="containerPickup.container_numbers"
                                placeholder="Copy paste the container nos. here. If the containers are in depot and are not damaged at the selected depot then you would be able to mark pick-up."
                                [name]="'description'" class="" fxLayout="column" [maxlength]="3000"
                                [errors]="errorObj.container_numbers || errorObj.agg_container_numbers">
                </app-text-field>
            </div>
            <ng-container *ngIf="selectDO.is_open_do==false">
                <logzy-containerlistforpickup [containersList]="containerList" fxFlex="40em"
                                              [pickupId]="pickupId"></logzy-containerlistforpickup>
            </ng-container>
            <div fxFlex="12em" fxLayout="column">
                <span class="inputTitle">Pick-up Date*</span>
                <app-date-field [isEditable]="true" [maxDate]="currentDate" [(ngModel)]="containerPickup.pickup_date"
                                [errors]="errorObj.pickup_date"></app-date-field>
            </div>

            <div fxFlex="12em" fxLayout="column"
                 *ngIf="(selectDO.supply_do?.request?.transaction_type=='supply') && (selectDO.do_owner?.dev_value == 'supplier') && (selectDO.supply_do.request?.request_type?.dev_name =='buy_sell')">
                <span class="inputTitle"> Invoice No</span>
                <app-text-field [isEditable]="true" [(ngModel)]="containerPickup.invoice_number" [name]="'description'"
                                class=""
                                fxLayout="column" [errors]="errorObj.invoice_number">
                </app-text-field>
            </div>

            <div fxFlex="12em" fxLayout="column"
                 *ngIf="(selectDO.supply_do?.request?.transaction_type=='supply') && (selectDO.do_owner?.dev_value == 'supplier') && (selectDO.supply_do.request?.request_type?.dev_name =='buy_sell')">
                <span class="inputTitle"> Invoice Date</span>
                <app-date-field [isEditable]="true" [maxDate]="currentDate" [(ngModel)]="containerPickup.invoice_date"
                                [name]="'invoice_date'">
                </app-date-field>
            </div>
            <div fxFlex="12em" fxLayout="column">
                <span class="inputTitle"> Pick-up Remarks</span>
                <app-text-field [isMultiline]="true" [maxlength]="3000" [isEditable]="true"
                                [(ngModel)]="containerPickup.remarks" [name]="'description'" class="" fxLayout="column"
                                [errors]="errorObj.remarks">
                </app-text-field>
            </div>

            <div fxFlex="12em" fxLayout="column"
                 *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'">
                <span class="inputTitle"> Ports*</span>
                <app-mat-auto-search [isEditable]="true" [(ngModel)]="containerPickup.port"
                                     [name]="'hsn_code'"
                                     [listUrl]="port_url + 'location/?depot_id=' + selectDO.depot?.id + '&search=::search::'"
                                     [displayField]="'name_display'"
                                     fxFlex="14.3em" fxLayout="column" [errors]="errorObj.port"
                                     class="align-items-center">
                </app-mat-auto-search>
            </div>
            <div fxFlex="100" class="reviewBtn" *ngIf="!review">
                <button mat-raised-button class="Save" [disabled]="disableValidateContainers"
                        (click)="selectDO.is_open_do ? postDOContainerPickup(containerPickup) : postDOContainerPickupDetails()">
                    <span *ngIf="!disableValidateContainers">Save Pick-up
                        Details</span>
                    <div *ngIf="disableValidateContainers" class="p03">
                        <i class="flaticon-loading spin"></i>
                        <span>Saving...</span>
                    </div>
                </button>
            </div>
        </div>
        <!-- <div class="inputs" fxLayout="row wrap">
            <div fxFlex="50%" fxLayout="column">
                <span class="inputTitle">Container No*</span>
                <app-text-field [isMultiline]="true" [isEditable]="true"
                    [(ngModel)]="this.container_nums"
                    placeholder="Copy paste the container no here. If the containers are in EY state at the selected depot, you would be able to mark it quick"
                    [name]="'description'" class="" fxLayout="column" >
                </app-text-field>
            </div>
            <div fxFlex="12em" fxLayout="column">
                <span class="inputTitle">Pick-up Date*</span>
                <app-date-field [isEditable]="true" [maxDate]="currentDate"
                    [(ngModel)]="this.pick_up" ></app-date-field>
            </div>
            <div fxFlex="12em" fxLayout="column">
                <span class="inputTitle">Pick-up Remarks, if any*</span>
                <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="this.remark"
                    [name]="'description'" class="" fxLayout="column" >
                </app-text-field>
            </div>
            <div fxFlex="100" class="reviewBtn" *ngIf="!review">
                <button mat-raised-button class="Save" (click)="postDOContainerPickup()"> Review Data</button>
            </div>
        </div> -->

    </ng-container>
    <ng-container *ngIf="review">
        <div [classList]="Canvas" *ngFor="let item of containerPickupResponse; index as i">
            <p>container no.</p>

            <div #mySidepanel [classList]="open">

                <span>Container number <b>{{containerSwapWith}}</b> is getting swapped with: </span>
                <app-select-field [isEditable]="true" [(ngModel)]="pickupObject.container" [name]="'container'"
                                  [displayField]="'container_number'" [options]="containerID" fxLayout="column">
                </app-select-field>
                <button mat-stroked-button (click)="updateDOContainerPickup(item,i)" class="sleekBtn Save"> OK</button>
            </div>
        </div>

        <div class="t1 t1p">
            <span class="desc">Review, clean and save data</span>
        </div>
        <div>
            <div class="HeaderSet">
                <span fxFlex="13.3">Container No</span>
                <span fxFlex="11">Size-type (Condition)</span>
                <span fxFlex="26.4">Current Depot Name</span>
                <span fxFlex="17.6">Pick-up Date</span>
                <span fxFlex="15">Pick-up Remarks</span>
                <span fxFlex="8" class="text-center">Action</span>

            </div>
            <div class="rowSetBackground">
                <div class="rowSet" *ngFor="let item of containerPickupResponse;index as i">
                    <span fxFlex="13.3" class="imp">{{item.container?.container_number}}</span>
                    <span fxFlex="11">
                        {{item?.container?.container_size_type}}
                    </span>
                    <span fxFlex="26.4" class="imp">{{selectDO.depot?.display_name}}</span>
                    <app-date-field [isEditable]="true" fxFlex="17.6"
                                    [(ngModel)]="containerPickupResponse[i].pickup_date"></app-date-field>
                    <app-text-field [isMultiline]="true" fxFlex="15" [isEditable]="true"
                                    [(ngModel)]="containerPickupResponse[i].user_remark" [name]="'remarks'" class=""
                                    fxLayout="column">
                    </app-text-field>
                    <button mat-button [matMenuTriggerFor]="menu" fxFlex="8" class="actions">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="updateDOContainerPickup(item,i)">Update</button>
                        <button mat-menu-item (click)="opendailog(item.container?.container_number)">Swap
                                                                                                     Container
                        </button>
                    </mat-menu>
                </div>
            </div>
            <!-- //when Fronten Create Table -->
            <!-- <div class="rowSetBackground">
                <div class="rowSet" *ngFor="let item of container_nums_arr;index as i">
                    <span fxFlex="13.3" class="imp">{{item}}</span>
                    <span fxFlex="11">
                        {{item?.container?.container_size_type}}
                    </span>
                    <span fxFlex="26.4" class="imp">{{this.selectDO.depot?.display_name}}</span>
                    <app-date-field [isEditable]="true" fxFlex="17.6"
                        [(ngModel)]="this.pickupObject.pickup_date"></app-date-field>
                    <app-text-field [isMultiline]="true" fxFlex="15" [isEditable]="true"
                        [(ngModel)]="this.pickupObject.user_remark" [name]="'remarks'" class=""
                        fxLayout="column">
                    </app-text-field>
                    <button mat-button [matMenuTriggerFor]="menu" fxFlex="8" class="actions">
                        <mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="updateDOContainerPickup(item,i)">Update</button>
                        <button mat-menu-item (click)="opendailog(item.container?.container_number)">Swap
                            Container</button>
                    </mat-menu>
                </div>
                <button mat-menu-item (click)="postDOContainerPickup()">Save Pick-up Details</button>

            </div> -->


        </div>
        <!-- <div fxFlex="100" class="reviewBtn">
            <button mat-raised-button class="Save" (click)="updatePickupbydoID(containerPickupResponse)"> Save Pick-up
                Details</button>
        </div> -->
    </ng-container>
</ng-container>
<ng-container *ngIf="swapContainer">
    <div [classList]="Canvas" *ngFor="let item of containerPickupResponse; index as i">
        <div #mySidepanel [classList]="open">
            <span>Container number <b>{{containerSwapWith}}</b> is getting swapped with: </span>
            <app-select-field [isEditable]="true" [(ngModel)]="pickupObject.container" [name]="'container'"
                              [displayField]="'container_number'" [options]="containerID" fxLayout="column">
            </app-select-field>
            <p>Product only</p>
            <button mat-stroked-button (click)="updateDOContainerPickup(item,i)" class="sleekBtn Save"> OK</button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="markedPickup">
    <div class="confirmation">
        <img src="assets/images/backgrounds/marked_pick_up.jpg" alt="">

        <span>Congratulations! You have successfully marked pick-up of 4 containers for Release No: ARCU1223_DO_1</span>
        <div class="confBtn">
            <button mat-raised-button class="Save" (click)="markedPickup=false"> Add Return Reference</button>
            <button mat-raised-button class="Save" (click)="markedPickup=false"> Mark more Pick-up</button>
        </div>
    </div>
</ng-container>